<template>
  <wh-popup-dynamic-select
    :label="label"
    :value="value"
    :extra-params="extraParams"
    search-name="landName"
    :show-picker.sync="pickerShow"
    :placeholder="placeholder"
    history-key="landSelect"
    data-src="/api/getFarmlandList"
    :rules="rules"
  >
    <template #list="{list}">
      <div class="land-list">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="land-list-item van-hairline--bottom"
          :title="index"
          @click="selectLand(item)"
        >
          <div class="land-name">
            {{ item.landName }}
          </div>
          <van-tag round class="tag" color="#f7f7f7" text-color="#404040">
            {{ item.cropList.length ? '使用中': '闲置中' }}
          </van-tag>
        </div>
      </div>
    </template>
  </wh-popup-dynamic-select>
</template>

<script>
import WhPopupDynamicSelect from '@/components/public/WhPopupSelect/WhPopupDynamicSelect'
export default {
  name: 'LandPopupSelect',
  components: { WhPopupDynamicSelect },
  props: {
    value: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: '移栽至'
    },
    companyId: {
      type: Number,
      default: undefined
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
    landId: {
      type: Number,
      default: undefined
    },
    landName: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: '请选择地块'
    }
  },
  data() {
    return {
      extraParams: {
        fuzzy: 1,
        landName: undefined,
        companyId: this.$store.getters.companyId
      },
      pickerShow: false
    }
  },
  methods: {
    selectLand(item) {
      // console.log('item = ', item)
      this.pickerShow = false // 隐藏选择弹窗
      this.$emit('update:landName', item.landName)
      this.$emit('update:landId', item.id)
      this.$emit('selectLand', item)
    }
  }
}
</script>

<style lang='less' scoped>
.land-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  .land-name {
    font-size: 14px;
    font-weight: 600;
  }
  .tag {
    margin-top: 6px;
    font-size: 12px;
    padding: 0.2em 0.5em;
  }
}
</style>
